module.exports = __webpack_public_path__ + "img/e_voucher_logo_portrait_white_conasi.eb9d01b1.png";